import React from "react";
import { parseHtml } from "@/utils/common";
interface Props {
  title: string;
  description: string;
}
const Benefits: React.FC<Props> = ({ title, description }) => {
  return (
    <div className="py-8 px-4 border border-gray-700 group">
      <h3 className="text-heading-5 font-bold text-primary-text-white">
        {title}
      </h3>
      <p className="text-subtitle-2 font-regular text-gray-400 mt-2 group-hover:text-secondary-text-white transition-all duration-300">
        {parseHtml(description)}
      </p>
    </div>
  );
};

export default Benefits;
